import React from 'react';

interface ClubStatProps {
  /** Null hides the stat entirely (e.g. managers count for non-owners). */
  value: number | null;
  label: string;
}

export const ClubStat: React.FC<ClubStatProps> = ({ value, label }) => {
  if (value === null) return null;

  return (
    <div className="flex flex-col">
      <span className="font-gilroy text-[18px] font-bold leading-none text-gc-ink tabular-nums">
        {value}
      </span>
      <span className="mt-[3px] text-[12px] font-medium text-gc-muted">
        {label}
      </span>
    </div>
  );
};
